import {FC} from 'react'
import {Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterContracts, resetFilterContracts} from '../../../redux/slices/filterSlices'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import { hasFilterProps } from './helpers'

interface ButtonGroupsProps {
  // role?: 'admin' | 'null' | 'salesAnper' | 'salesAdmin' | 'otorisator' | 'finance'
  role?: string
  hasExportAccess?: boolean
  hasCreateContractAccess?: boolean
  isDownloadLoading?: boolean
  onReloadTable: () => void
  onDownload?: () => void
  onCreateContract?: () => void
}

export const ButtonGroups: FC<ButtonGroupsProps> = (props) => {
  const {t} = useTranslation()
  const {filterContracts: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handlePageSizeChange = (value: number | undefined | null) => {
    dispatch(setFilterContracts({...filter, per_page: value ?? 5}))
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-contract-filter') as string)
      if(hasFilterProps(persisted)){
        return persisted
      }

      return null
    }catch(e){ return null }
  }

  const handleResetFilter = () => {
    dispatch(resetFilterContracts())
  }

  return (
    <StyledButtonGroups
      leftContent={<>
        <SelectPageSize
          initialValue={filter?.per_page ?? 5}
          onChange={(value: any) => handlePageSizeChange(value?.value)}
        />
        
        { hasFilter() && <button type="button" onClick={() => handleResetFilter()} className="btn btn-outline-danger btn-sm">Clear Filter</button> }
      </>
      }
      rightContent={
        <>
          {props.hasCreateContractAccess && (
            <div
              className='card-toolbar'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('add-kontrak')}
            >
              <Link
                to='/management/kontrak/create'
                className='btn btn-primary d-flex align-items-center me-2 h-100'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('kontrak-tambah')}</p>
              </Link>
            </div>
          )}

          {props.hasExportAccess && (
            <button
              className='btn btn-primary me-2'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title={t('unduh')}
              onClick={props.onDownload}
              disabled={props.isDownloadLoading}
            >
              {props.isDownloadLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('Unduh')
              )}
            </button>
          )}

          <button
            className='btn btn-sm btn-primary'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='/hover'
            title={t('reload table')}
            onClick={props.onReloadTable}
          >
            <i className='fas fa-sync-alt'></i>
          </button>
        </>
      }
    />
  )
}

ButtonGroups.defaultProps = {
  role: 'null',
  hasExportAccess: false,
  isDownloadLoading: false,
}
